import { Button as MuiButton } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ProgressionTypes } from 'utils/activityPlan';
import { DraggableProgression } from '../DraggableProgression';
import { createExerciseDropStage } from '../ProgressionStage';
import { EditableAcuteWeekHeader } from './EditableAcuteWeekHeader';

const AddExerciseButton = styled(MuiButton)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export interface EditableAcuteWeekProps {
  id: string;
  children: React.ReactNode;
  week: number;
  index: number;
  etSessionTime: number;
  current: boolean;
  onCopyUniqueExercises: () => void;
  onCopyAllExercises: () => void;
  onDelete: () => void;
  onAddNewExercises: () => void;
  onDuplicateWeek: () => void;
  canCopyExercises: boolean;
  isDuplicateDisabled: boolean;
  expanded: boolean;
}

export const EditableAcuteWeek = ({
  id,
  week,
  index,
  current,
  etSessionTime,
  children,
  expanded,
  canCopyExercises,
  onCopyUniqueExercises,
  onCopyAllExercises,
  onDelete,
  onAddNewExercises,
  onDuplicateWeek,
  isDuplicateDisabled
}: EditableAcuteWeekProps): JSX.Element => {
  const [localExpanded, setExpanded] = useState<boolean>(expanded);

  useEffect(() => {
    setExpanded(expanded);
  }, [expanded]);

  return (
    <DraggableProgression
      expanded={localExpanded}
      mainComponent={createExerciseDropStage(id)}
      draggableId={id}
      scrollToId={`${ProgressionTypes.acute}${week}`}
      index={index}
      header={
        <EditableAcuteWeekHeader
          id={id}
          week={week}
          etSessionTime={etSessionTime}
          current={current}
          onToggleCollapse={() => setExpanded(!localExpanded)}
          expanded={localExpanded}
          canCopyExercises={canCopyExercises}
          onCopyUniqueExercises={onCopyUniqueExercises}
          onCopyAllExercises={onCopyAllExercises}
          onDelete={onDelete}
          onDuplicate={onDuplicateWeek}
          isDuplicateDisabled={isDuplicateDisabled}
        />
      }
      footer={
        <AddExerciseButton
          variant="outlined"
          color="primary"
          size="large"
          startIcon={<AddIcon />}
          onClick={onAddNewExercises}
          data-testid={`${id}AddExerciseButton`}
        >
          Add Exercise
        </AddExerciseButton>
      }
    >
      {children}
    </DraggableProgression>
  );
};
